export const environment = {
  production: false,
  newBackOfficeUrl: "/bo-new/api/",
  feedStatusUrl: "feed-status/"
};
